import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, getToken, Messaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDCtBkfMjDs6SOvE7zTCX1BhcNMeYSRTfM",
  authDomain: "hec-nrpu.firebaseapp.com",
  projectId: "hec-nrpu",
  storageBucket: "hec-nrpu.firebasestorage.app",
  messagingSenderId: "290165789314",
  appId: "1:290165789314:web:67c594ea5254aadb1b9a9b",
  measurementId: "G-HJGEMMQFZR"
};

// VAPID public key for web push
export const VAPID_KEY = "BBi5nesoxX8WiJlugCX9-q0R6cEeR_CK5ZSHXVfwypucvOtiUCDlFVZCp8OMQLgZC_JUMNurlu0ABpyGJzY0OGQ";

// Initialize Firebase
let app: FirebaseApp | null = null;
let messaging: Messaging | null = null;

export const initializeFirebase = (): FirebaseApp => {
  if (!app) {
    app = initializeApp(firebaseConfig);
  }
  return app;
};

export const getFirebaseMessaging = (): Messaging | null => {
  if (typeof window === 'undefined') {
    return null; // Server-side rendering
  }

  if (!app) {
    initializeFirebase();
  }

  if (!messaging && app) {
    try {
      messaging = getMessaging(app);
    } catch (error) {
      console.error('Error initializing Firebase Messaging:', error);
      return null;
    }
  }

  return messaging;
};

export default firebaseConfig;
